import React, { useState, useEffect } from "react";
import { Container, Grid, Box, TextField, InputAdornment,  IconButton, Modal, Button, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Pagination from "../common/Pagination";
import Skeleton from "../common/Skeleton";
import CONSTANTS, { DEMO_USER_LIST_CONSTANTS, LIST_LIMIT, USER_LIST_CONSTANTS } from "../../constants/constants";
import MUIDataTable from "mui-datatables";
import SearchIcon from "@mui/icons-material/Search";
import lazyTypingUtils from "../../utils/lazyTypingUtils";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { ROUTES } from "../../constants/routes";
import CommonButton from "../common/Button";
import PageTitle from "../common/PageTitle";
import { DemoUsersType, DemoUsersWithPaginationType } from "../../interfaces/DemoUserinterface";
import DemoUserService from "./service/demoUsersService";
import Utility from "../../utils/Utility";
import { commonActions } from "../../redux/features/common/commonSlice";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import StoreService from "../Store/service/StoreService";
import Cookies from "../../utils/Cookies";
import sign from "jwt-encode";
import { API } from "../../config";
import { Padding } from "@mui/icons-material";
import { SearchIconButton } from "../../utils/searchUtils";

const DemoUsers = (props: any) => {
    const { showSnackbar, handleLoader } = props;
    const utility = new Utility();
    const [t] = useTranslation();
    const dispatch = useAppDispatch();
    const pathName = window.location.pathname;
    const perPageLimit = useAppSelector((state) => state.common.perPageLimit);
    const [limit, setLimit] = useState(!perPageLimit ? LIST_LIMIT.DEMO_STORE_LIST_LIMIT : perPageLimit );
    const [demoUserListData, setDemoUserListData] =  useState<DemoUsersWithPaginationType>();
    const [currentPage, setCurrentPage] = useState(1);
    localStorage.setItem(pathName, currentPage.toString());
    const firstPage = Number(localStorage.getItem(pathName));
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [skeleton, setSkeleton] = useState(true);
    const [search, setSearch] = useState<string>("");
    const [isSearchChange,setIsSearchChange]=useState<boolean>(false);
    const [hideColumnArr,setHideColumnArr] = useState<any>([]);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [hideEmail, setHideEmail] = useState(false);
    const [hideExpirationDate, setHideExpirationDate] = useState(false);
    const [selectedItem, setSelectedItem] = useState<DemoUsersType | null>(null);
    const apiData: any[][] = [];
    const currentDateString = utility.getCurrentTimestamp();
    const [colFilter,setColFilter] =useState<string>("");
    const [direction,setDirection]=useState<string>("");
    const [colName,setColName]=useState<string>("");
    const [selectedSellerDetails, setSelectedSellerDetails] = useState<any>();
    const [showDetailModal, setShowDetailModal] = useState<boolean>(false);

    const onsearchApicall = () =>{
        if(isSearchChange){
            demoUserListApi(firstPage, limit);
        }
    };
    const propItem = [onsearchApicall, search];
    lazyTypingUtils(propItem);

    const demoUserListApi = (currentPage: number, limit: number) => {
        setIsSearchChange(false);
        setSkeleton(true);
        const isHitDummyURL = false;
        new DemoUserService({}, isHitDummyURL)
            .demoUserList(currentPage,limit,search,colFilter,direction)
            .then((res:DemoUsersWithPaginationType) => {
                setCurrentPage(currentPage);
                setLimit(limit);
                setHideEmail(true);
                setHideExpirationDate(true);
                setDemoUserListData(res);
                setTotalCount(res.pagination.totalCount);
                setTotalPages(res.pagination.totalPages);
                setSkeleton(false);
            })
            .catch((err:any) => {
                showSnackbar(err?.message, false);
                setSkeleton(false);
            });
    };

    const createDemoUserApiCall = () => {
        handleLoader(true);
        const payload = {};
        const isHitDummyURL = false;
        new DemoUserService(payload, isHitDummyURL)
            .createDemoUser()
            .then((res) => {
                setHideEmail(true);
                setHideExpirationDate(true);
                handleLoader(false);
                showSnackbar(res.message, true);
                demoUserListApi(firstPage, limit);
                setTimeout(()=>close(), 1000);
            })
            .catch((err) => {
                handleLoader(false);
                showSnackbar(err?.message, false);
            });
    };

    const navigateInvitePage = (demoStoreId:number,isRevokeAndInvite:boolean) => {
        (window as any).demoUserListApi = demoUserListApi;
        (window as any).demoUserFirstPage = firstPage;
        (window as any).demoUserLimit = limit;
        const url = `${ROUTES.DEMO_INVITE_PAGE}?demoStoreId=${demoStoreId}&isRevokeAndInvite=${isRevokeAndInvite}`;
        open(url, "_blank");
    };
    const navigateInviteRevokePage = (demoStoreId:number,isRevokeAndInvite:boolean) => {
        const url = `${ROUTES.DEMO_INVITE_PAGE}?demoStoreId=${demoStoreId}&isRevokeAndInvite=${isRevokeAndInvite}`;
        open(url, "_blank");
    };
 
    const handleSearchChange = (e: any) => {
        setIsSearchChange(true);
        const { value } = e.target;
        setSearch(value);
    };
    const handleDemoUserInvite = (demoStoreId:number,isRevokeAndInvite:boolean) => {
        navigateInvitePage(demoStoreId,isRevokeAndInvite);
        setHideEmail(true);
        setHideExpirationDate(true);
    };
    const handleDemoUserInviteRevoke = (demoStoreId:number,isRevokeAndInvite:boolean) => {
        navigateInviteRevokePage(demoStoreId,isRevokeAndInvite);
    };

    const handleDemoUserRevoke = (item: DemoUsersType | null) => {
        handleLoader(true);
        const payload = {
            demoUserId: item?.id,
            revokeAndInvite: false,
            email: item?.email,
        };
        const isHitDummyURL = false;
        new DemoUserService(payload, isHitDummyURL)
            .revokeUser()
            .then((res) => {
                handleLoader(false);
                showSnackbar(res.message, true);
                demoUserListApi(firstPage, limit);
                closeModal();
            })
            .catch((err) => {
                handleLoader(false);
                closeModal();
                showSnackbar(err?.message, false);
            });
    };

    const redirectToSellerPanel = () => {
        const { storeID, userID,demoUser } = selectedSellerDetails;
        const accessToken = new Cookies("access-token").read();
        const code = sign({
            accessToken,
            storeID,
            userID,
            demoUser
        }, CONSTANTS.JWT_SECRET_KEY);
        window.open(`${API.ADMIN_AUTH_SELLER_PANEL_URL_DEMO}?code=${code}`, "_blank");
    };

    const handleShowDetailClick = () => {
        setShowDetailModal(true);
    };

    const handleShowDetailModalYes = async () => {
        setShowDetailModal(false);
        handleLoader(true);
        await new StoreService().refreshAccessToken();
        handleLoader(false);
        redirectToSellerPanel();
    };

    const handleShowDetailModalNo = () => {
        setShowDetailModal(false);
        setSelectedSellerDetails(null);
    };



    const actionButton = (
        status: number,
        demoStoreId: number,
        item: DemoUsersType,
        userID: number,
        storeID: number,
        isDisabled: boolean
    ) => {
        return (
            <>
                <Grid container xs={9}>
                    <Grid item xs={8} sx={{ display: "flex", justifyContent: "center" }}>
                        {status === 0 && (
                            <CommonButton
                                route={window.location.pathname}
                                functionToExecute={() => handleDemoUserInvite(demoStoreId,false)}
                                btnName={t("demo_users.invite")}
                            />
                        )}
                        {status === 1 && (
                            <CommonButton
                                route={window.location.pathname}
                                functionToExecute={() => deleteModalOpen(item)}
                                btnName={t("demo_users.revoke")}
                                sx={{background:"#F29810", textTransform: "capitalize"}}
                            />
                        )}
                        {status === 2 && (
                            <CommonButton
                                route={window.location.pathname}
                                functionToExecute={() => handleDemoUserInviteRevoke(demoStoreId,true)}
                                btnName={t("demo_users.revoke_invite")}
                                sx={{background:"#F29810", textTransform: "capitalize"}}
                            />
                        )}
                    </Grid>
                    <Grid item xs={4}>
                        <CommonButton
                            route={window.location.pathname}
                            functionToExecute={() => {
                                setSelectedSellerDetails({
                                    userID,
                                    storeID,
                                    demoUser:true
                                });
                                handleShowDetailClick();
                            }}
                            btnName={t("stock_page.detail")}
                            disableCondition={isDisabled}
                        />
                    </Grid>
                </Grid>
            </>
        );
    };

    const dateComparison = (expirationDateString: string): boolean => {
        const expirationTime = expirationDateString.replace(/\//g, "-").replace(" ", "T");
        const currentTime = utility.getCurrentTimeInJst();
        return new Date(expirationTime) < new Date(currentTime);
    };

    const demoUserStatusColorValue = (expirationDate: string,value: string) => {
        return (
            <Box sx={{ color: !dateComparison(expirationDate)? "black" : "red" }}>{value}</Box>
        );
    };

    const apiTableData = () => {
        {
            demoUserListData?.demoUsersLogs?.map(
                (item: DemoUsersType, index: number) => {
                    const isDisabled = ((item.status == DEMO_USER_LIST_CONSTANTS.STATUS_IDLE) || (item.status == DEMO_USER_LIST_CONSTANTS.STATUS_INVITED )) || (item?.storeID ? false : true) || (dateComparison(item.expirationDate));
                    const status =
            item.status == DEMO_USER_LIST_CONSTANTS.STATUS_IDLE || !item.expirationDate
                ? actionButton(DEMO_USER_LIST_CONSTANTS.STATUS_IDLE, item?.id, item,item?.userID,item?.storeID, isDisabled)
                : dateComparison(item.expirationDate) && item.status == DEMO_USER_LIST_CONSTANTS.STATUS_INVITED
                    ? actionButton(DEMO_USER_LIST_CONSTANTS.STATUS_ACCEPTED, item?.id, item,item?.userID,item?.storeID, isDisabled)
                    : actionButton(DEMO_USER_LIST_CONSTANTS.STATUS_INVITED, item?.id, item,item?.userID,item?.storeID, isDisabled);
                    const emailToShow = hideEmail && (item.status === DEMO_USER_LIST_CONSTANTS.STATUS_IDLE) ? "": item?.email;
                    const expirationToShow = hideExpirationDate && (item.status === DEMO_USER_LIST_CONSTANTS.STATUS_IDLE) ? "": item?.expirationDate;
                    apiData[index] = [];
                    apiData[index].push(
                        (currentPage - 1) * limit + index + 1,
                        item?.storeCode,
                        emailToShow,
                        expirationToShow,
                        demoUserStatusColorValue(item?.expirationDate, item?.statusText),
                        status
                    );
                }
            );
        }
    };
   
    apiTableData();

    const handleSorting =(changedColumn:any)=>{
        if(colName!=changedColumn){
            setDirection("asc");

        }else{
            setDirection(direction=="asc"? "desc":"asc");
        }
        
        setColName(changedColumn);   
        const columnName=changedColumn == "Store Code" || changedColumn=="ストアコード" ? "store_code" :  changedColumn == "Expiration Date" || changedColumn=="有効期限" ? "expiration_date":"";
          
        setColFilter(columnName);

    };
 
    const columns = [
        {
            name: t("stock_page.s_no"),
            options: {
                filter: true,
                sort: false,
                display: hideColumnArr.includes("No.") ? false : true,
                setCellProps: () => ({
                    style: {
                        wordBreak: "break-word",
                        width: 50,
                    },
                }),
            },
        },
        {
            name: t("demo_users.store_code"),
            options: {
                filter: false,
                sort: false,
                setCellProps: () => ({
                    style: {
                        wordBreak: "break-word",
                        width: 150,
                    },
                }),
                display: hideColumnArr.includes("ストアコード") ? false : true,
                customHeadLabelRender: (data:any) => {
                    return (
                        <Box>
                            {data.label}
                            <IconButton color="primary" size="small" onClick={()=>handleSorting(data.name)} >
                                {colFilter!="store_code" ? <SwapVertIcon className="swapVertIcon"/> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition" />:<ArrowDownwardIcon className="sortingIconPosition"/> }
                            </IconButton>  
                        </Box>
                    );
                },
            },
        },
        {
            name: t("demo_users.email"),
            options: {
                filter: false,
                sort: false,
                setCellProps: () => ({
                    style: {
                        wordBreak: "break-word",
                        width: 400,
                    },
                }),
                display: hideColumnArr.includes("メールアドレス") ? false : true,    
            },
        },
        {
            name: t("demo_users.expiration_date"),
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({
                    style: {
                        wordBreak: "break-word",
                        width: 250,
                    },
                }),
                display: hideColumnArr.includes("有効期限") ? false : true,  
                customHeadLabelRender: (data:any) => {
                    return (
                        <Box>
                            {data.label}
                            <IconButton color="primary" size="small" onClick={()=>handleSorting(data.name)} >
                                {colFilter!="expiration_date" ? <SwapVertIcon className="swapVertIcon" /> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition"/>:<ArrowDownwardIcon className="sortingIconPosition"/> }
                            </IconButton> 
                        </Box>
                    );
                },
            },
        },
        {
            name: t("demo_users.status"),
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({
                    style: {
                        wordBreak: "break-word",
                        width: 200,
                    },
                }),
                display: hideColumnArr.includes("ステータス") ? false : true,
            },
        },
        {
            name: t("demo_users.action"),
            options: {
                filter: true,
                sort: false,
                setCellHeaderProps: () => ({
                    style: {
                        paddingLeft: 140,
                        paddingRight: 140,
                    },
                }),
                setCellProps: () => ({
                    style: {
                        wordBreak: "break-word",
                        width: 50,
                    },
                }),
                display: hideColumnArr.includes("アクション") ? false : true,
            },
        },
    ];

    const deleteModalOpen = (item:DemoUsersType) => {
        setModalOpen(true);
        setSelectedItem(item);
    };
    const createModal = () => {
        setCreateModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedItem(null);
    };
    const createCloseModal = () => {
        setCreateModalOpen(false);
    };

    useEffect(() => {
        demoUserListApi(firstPage, limit);
    }, [colFilter,direction]);

    return (
        <Box className="main">
            <Container>
                <Grid container spacing={0} sx={{ py: 5 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ py: 2 }}>
                        <PageTitle title={t("demo_users.demo_store_list")} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ py: 6 }}>
                        <CommonButton
                            route={window.location.pathname}
                            functionToExecute={createModal}
                            className="store_invite_btn"
                            btnName={t("demo_users.add_demo_account")}
                            disableCondition={false}
                            startIconRequired={<AddCircleIcon />}
                        />
                    </Grid>
                </Grid>
            </Container>
 
            <Container className="first_table_cell_small_width"sx={{ minWidth: "1200px"}}>
 
                <Grid container spacing={0} sx={{ py: 1 }}>
                    <Grid item xs={12} sm={6} md={4} lg={3} sx={{ py: 1, px: 2 }}>
                        <TextField
                            id="input-with-icon-textfield"
                            label={t("demo_users.search_place_holder")}
                            onChange={handleSearchChange}
                            value={search}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIconButton
                                            setIsSearchChange={setIsSearchChange}
                                            apiCallFunction={demoUserListApi}
                                            page={currentPage}
                                            limit={limit}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                            variant="standard"
                            fullWidth
                        />
                    </Grid>
                </Grid>
                {skeleton ? (
                    <Skeleton
                        varient="rectangular"
                        width={0}
                        height={60}
                        count="10"
                        my={0}
                    />
                ) : (
                    <>
                        <Box
                            sx={{
                                overflowX: "auto",
                                WebkitOverflowScrolling: "touch",
                            }}
                        >
                            <Box sx={{ minWidth: 1200,display: "block"}}>
                                <MUIDataTable
                                    title={""}
                                    columns={columns}
                                    data={apiData}
                                    options={{
                                        pagination: false,
                                        print: false,
                                        download: false,
                                        filter: false,
                                        search: false,
                                        selectableRowsHideCheckboxes: true,
                                        textLabels: {
                                            body: {
                                                noMatch: t("table_text.no_match").toString(),
                                            },
                                            viewColumns: {
                                                title: t("table_text.show_columns").toString(),
                                                titleAria: "Show/Hide Table Columns",
                                            },
                                            toolbar: {
                                                search: t("table_text.search").toString(),
                                                viewColumns: t("table_text.view_columns").toString(),
                                            },
                                        },
                                        searchPlaceholder: t(
                                            "table_text.search_placeholder"
                                        ).toString(),
                                        responsive: "standard",
                                        onSearchChange: (searchText: any) => {
                                            setSearch(searchText ? searchText : "");
                                        },
                                        onViewColumnsChange: (changedColumn:string,action:string) => {
                                            const tempHideColArr=[...hideColumnArr];
                                            if(action==="remove"){
                                                changedColumn=="Store Code"?
                                                    tempHideColArr.push("ストアコード"):
                                                    changedColumn=="Corporation Name"?
                                                        tempHideColArr.push("法人名"):
                                                        changedColumn=="Store Name"?
                                                            tempHideColArr.push("出品代表者名"):
                                                            changedColumn=="Email Address"?
                                                                tempHideColArr.push("メールアドレス"):
                                                                changedColumn=="Status"?
                                                                    tempHideColArr.push("ステータス"):
                                                                    changedColumn=="Action"?
                                                                        tempHideColArr.push("アクション"):                                              
                                                                        tempHideColArr.push(changedColumn);
                                                setHideColumnArr(tempHideColArr);
                                            }
                                            else{
                                                let index =-1;
                                                changedColumn=="Store Code"?
                                                    index = tempHideColArr.indexOf("ストアコード"):
                                                    changedColumn=="Corporation Name"?
                                                        index = tempHideColArr.indexOf("法人名"):
                                                        changedColumn=="Store Name"?
                                                            index = tempHideColArr.indexOf("出品代表者名"):
                                                            changedColumn=="Email Address"?
                                                                index = tempHideColArr.indexOf("メールアドレス"):
                                                                changedColumn=="Status"?
                                                                    index = tempHideColArr.indexOf("ステータス"):
                                                                    changedColumn=="Action"?
                                                                        index = tempHideColArr.indexOf("アクション"):
 
                                                                        index = tempHideColArr.indexOf(changedColumn);
                                                tempHideColArr.splice(index,1);
                                                setHideColumnArr(tempHideColArr);
                                            }
                                        }  
                                    }}
                                />
                            </Box>
                        </Box>
                       
                    </>
                )}
                <Pagination
                    totalCount={totalCount}
                    currentPage={currentPage}
                    pageChange={demoUserListApi}
                    totalPage={totalPages}
                    rowsPerPage={limit}
                    rowsPerPageChange={setLimit}
                />
            </Container>
            <Modal
                open={modalOpen}
                onClose={closeModal}
                aria-labelledby="delete-modal-title"
                aria-describedby="delete-modal-description"
            >
                <Box className="center-model" sx={{ p: 4 }}>
                    <Typography
                        id="delete-modal-title"
                        variant="h6"
                        component="h2"
                    ></Typography>
                    <Typography id="delete-modal-description" sx={{ m: 2 }}>
                        {t("demo_users.confirm_message")}
                    </Typography>
                    <Button
                        sx={{ m: 2, p: 1 }}
                        onClick={() =>{
                            handleDemoUserRevoke(selectedItem);
                            closeModal();
                        }}
                    >
                        {t("demo_users.yes")}
                    </Button>
                    <Button sx={{ m: 2, p: 1 }} onClick={closeModal}>
                        {t("demo_users.no")}
                    </Button>
                </Box>
            </Modal>

            <Modal
                open={createModalOpen}
                onClose={createCloseModal}
                aria-labelledby="delete-modal-title"
                aria-describedby="delete-modal-description"
            >
                <Box className="center-model" sx={{ p: 4 }}>
                    <Typography
                        id="delete-modal-title"
                        variant="h6"
                        component="h2"
                    ></Typography>
                    <Typography id="delete-modal-description" sx={{ m: 2 }}>
                        {t("demo_users.create_user_confirm_message")}
                    </Typography>
                    <Button
                        sx={{ m: 2, p: 1 }}
                        onClick={() =>{
                            createDemoUserApiCall();
                            createCloseModal();
                        }}
                    >
                        {t("demo_users.yes")}
                    </Button>
                    <Button sx={{ m: 2, p: 1 }} onClick={createCloseModal}>
                        {t("demo_users.no")}
                    </Button>
                </Box>
            </Modal>

            <Modal
                open={showDetailModal}
                aria-labelledby="delete-modal-title"
                aria-describedby="delete-modal-description"
            >
                <Box className="center-model" sx={{ p: 4 }}>
                    <Typography
                        id="delete-modal-title"
                        variant="h6"
                        component="h2"
                    ></Typography>
                    <Typography id="delete-modal-description" sx={{ m: 2 }}>
                        {t("stock_page.open_store_management_screen_message")}
                    </Typography>
                    <Button id="openWindowButton" sx={{ m: 2, p: 1 }} onClick={handleShowDetailModalYes}>
                        {t("invited_user_list.yes")}
                    </Button>
                    <Button sx={{ m: 2, p: 1 }} onClick={handleShowDetailModalNo}>
                        {t("invited_user_list.no")}
                    </Button>
                </Box>
            </Modal>
        </Box>
    );
};
 
export default DemoUsers;
